export function getSuppressTracking(): Record<string, string> {
  return {
    'data-hj-suppress': '',
  }
}
